import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';

const About = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        
        <h1>About KwikLuv</h1>

        <section>
          <h2>Our Mission</h2>
          <p>
            KwikLuv is a modern adult dating platform designed for people seeking casual connections 
            without the complications of traditional relationships. We believe in honest, transparent 
            connections where everyone knows what they're looking for.
          </p>
        </section>

        <section>
          <h2>What Makes Us Different</h2>
          
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Privacy First</h3>
              <p>Your privacy matters. Control who sees your photos and information.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">✓</div>
              <h3>Verified Profiles</h3>
              <p>Get verified via quick video call to stand out and build trust with others.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💬</div>
              <h3>Direct Communication</h3>
              <p>Message and video call people you're interested in directly.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🌍</div>
              <h3>Location-Based</h3>
              <p>Find people near you with our distance filter feature.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">💎</div>
              <h3>Fair Pricing</h3>
              <p>Free for women. Affordable credits and subscriptions for men.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>Safe & Secure</h3>
              <p>Report and block features to keep your experience positive.</p>
            </div>
          </div>
        </section>

        <section>
          <h2>How It Works</h2>
          
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Create Your Profile</h3>
              <p>Sign up with email or phone. Add photos and tell us what you're looking for.</p>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <h3>Browse & Discover</h3>
              <p>Explore profiles in your area. Use filters to find exactly what you want.</p>
            </div>

            <div className="step">
              <div className="step-number">3</div>
              <h3>Connect & Chat</h3>
              <p>Send messages to people you're interested in. No swiping, no waiting for matches.</p>
            </div>

            <div className="step">
              <div className="step-number">4</div>
              <h3>Meet Up</h3>
              <p>Take conversations offline when you're both ready. Stay safe and have fun!</p>
            </div>
          </div>
        </section>

        <section>
          <h2>Our Values</h2>
          <ul className="values-list">
            <li><strong>Honesty:</strong> We believe in being upfront about what this platform is for.</li>
            <li><strong>Respect:</strong> Everyone deserves to be treated with dignity and respect.</li>
            <li><strong>Safety:</strong> We provide tools to help you stay safe online and offline.</li>
            <li><strong>Privacy:</strong> Your personal information is protected and never sold.</li>
            <li><strong>Inclusivity:</strong> All adults are welcome, regardless of background or preferences.</li>
          </ul>
        </section>

        <section>
          <h2>Safety & Reporting</h2>
          <p>
            Your safety is our top priority. We've built comprehensive tools to help you stay safe 
            and report any issues you encounter.
          </p>
          
          <h3>Report System</h3>
          <p>
            Found something concerning? Click the ⚠️ Report button on any profile to report:
          </p>
          <ul className="safety-tips">
            <li><strong>Harassment:</strong> Unwanted messages, threats, or abusive behavior</li>
            <li><strong>Fake Profile:</strong> Stolen photos, impersonation, or catfishing</li>
            <li><strong>Inappropriate Content:</strong> Explicit or offensive material</li>
            <li><strong>Spam:</strong> Promotional messages or bot accounts</li>
            <li><strong>Scam:</strong> Requests for money or suspicious activity</li>
            <li><strong>Other:</strong> Any other concerns or violations</li>
          </ul>
          <p>
            Our moderation team reviews all reports within 24 hours and takes appropriate action. 
            You'll be notified of the outcome.
          </p>

          <h3>Safety Tips</h3>
          <ul className="safety-tips">
            <li>Never share financial information or send money</li>
            <li>Meet in public places for first meetings</li>
            <li>Tell a friend where you're going</li>
            <li>Trust your instincts - if something feels off, it probably is</li>
            <li>Report suspicious behavior immediately using the ⚠️ button</li>
            <li>Use the app's messaging system until you're comfortable</li>
            <li>Block users who make you uncomfortable</li>
            <li>Look for verified badges (✓) for added trust</li>
          </ul>
        </section>

        <section>
          <h2>Pricing & Features</h2>
          <ul>
            <li><strong>Free for Women:</strong> All features completely free, including unlimited messaging</li>
            <li><strong>Credits for Men:</strong> Get 3 free messages, then buy credits (1 credit = 1 message)</li>
            <li><strong>Video Calls:</strong> Connect face-to-face with video calls (charged per minute in credits)</li>
            <li><strong>Creator Subscriptions:</strong> Subscribe to your favorite creators for exclusive photos, videos, and updates</li>
            <li><strong>Private Photo Unlocks:</strong> Unlock private photos with credits for one-time access</li>
            <li><strong>Profile Badges:</strong> Look for ✈️ (Available to travel) and 🅿️ (Parking available) badges</li>
            <li><strong>Verification Badge:</strong> Get verified via quick video call to build trust</li>
            <li><strong>No Hidden Fees:</strong> Only pay for what you use, credits never expire</li>
          </ul>
        </section>

        <section>
          <h2>Contact Us</h2>
          <p>Have questions or feedback? We'd love to hear from you!</p>
          <ul>
            <li>Email: <a href="mailto:support@kwikluv.com">support@kwikluv.com</a></li>
            <li>Support Form: <Link to="/contact">Contact Us</Link></li>
            <li>WhatsApp: <a href="https://wa.me/27123456789">+27 12 345 6789</a></li>
          </ul>
        </section>

        <section>
          <h2>Join Our Community</h2>
          <p>
            Ready to start your journey? <Link to="/register">Create your free account</Link> today 
            and discover what KwikLuv has to offer. No strings attached, just honest connections.
          </p>
        </section>
      </div>
    </div>
  );
};

export default About;
